import { CountryPrefix } from '../models/country-prefix.model';

export const countryPrefixes: Array<CountryPrefix> = [
  {
    name: 'Andorra',
    prefix: '+376',
    code: 'ad',
  },
  {
    name: 'United Arab Emirates',
    prefix: '+971',
    code: 'ae',
  },
  {
    name: 'Afghanistan',
    prefix: '+93',
    code: 'af',
  },
  {
    name: 'Antigua and Barbuda',
    prefix: '+1268',
    code: 'ag',
  },
  {
    name: 'Anguilla',
    prefix: '+1264',
    code: 'ai',
  },
  {
    name: 'Albania',
    prefix: '+355',
    code: 'al',
  },
  {
    name: 'Armenia',
    prefix: '+374',
    code: 'am',
  },
  {
    name: 'Angola',
    prefix: '+244',
    code: 'ao',
  },
  {
    name: 'Antarctica',
    prefix: '+672',
    code: 'aq',
  },
  {
    name: 'Argentina',
    prefix: '+54',
    code: 'ar',
  },
  {
    name: 'American Samoa',
    prefix: '+1684',
    code: 'as',
  },
  {
    name: 'Austria',
    prefix: '+43',
    code: 'at',
  },
  {
    name: 'Australia',
    prefix: '+61',
    code: 'au',
  },
  {
    name: 'Aruba',
    prefix: '+297',
    code: 'aw',
  },
  {
    name: 'Aland Islands',
    prefix: '+358',
    code: 'ax',
  },
  {
    name: 'Azerbaijan',
    prefix: '+994',
    code: 'az',
  },
  {
    name: 'Bosnia and Herzegovina',
    prefix: '+387',
    code: 'ba',
  },
  {
    name: 'Barbados',
    prefix: '+1246',
    code: 'bb',
  },
  {
    name: 'Bangladesh',
    prefix: '+880',
    code: 'bd',
  },
  {
    name: 'Belgium',
    prefix: '+32',
    code: 'be',
  },
  {
    name: 'Burkina Faso',
    prefix: '+226',
    code: 'bf',
  },
  {
    name: 'Bulgaria',
    prefix: '+359',
    code: 'bg',
  },
  {
    name: 'Bahrain',
    prefix: '+973',
    code: 'bh',
  },
  {
    name: 'Burundi',
    prefix: '+257',
    code: 'bi',
  },
  {
    name: 'Benin',
    prefix: '+229',
    code: 'bj',
  },
  {
    name: 'Saint Barthélemy',
    prefix: '+590',
    code: 'bl',
  },
  {
    name: 'Bermuda',
    prefix: '+1441',
    code: 'bm',
  },
  {
    name: 'Brunei Darussalam',
    prefix: '+673',
    code: 'bn',
  },
  {
    name: 'Bolivia (Plurinational State of)',
    prefix: '+591',
    code: 'bo',
  },
  {
    name: 'Brazil',
    prefix: '+55',
    code: 'br',
  },
  {
    name: 'Bahamas',
    prefix: '+1242',
    code: 'bs',
  },
  {
    name: 'Bhutan',
    prefix: '+975',
    code: 'bt',
  },
  {
    name: 'Botswana',
    prefix: '+267',
    code: 'bw',
  },
  {
    name: 'Belarus',
    prefix: '+375',
    code: 'by',
  },
  {
    name: 'Belize',
    prefix: '+501',
    code: 'bz',
  },
  {
    name: 'Canada',
    prefix: '+1',
    code: 'ca',
  },
  {
    name: 'Cocos (Keeling) Islands',
    prefix: '+61',
    code: 'cc',
  },
  {
    name: 'Democratic Republic of the Congo',
    prefix: '+243',
    code: 'cd',
  },
  {
    name: 'Central African Republic',
    prefix: '+236',
    code: 'cf',
  },
  {
    name: 'Republic of the Congo',
    prefix: '+242',
    code: 'cg',
  },
  {
    name: 'Switzerland',
    prefix: '+41',
    code: 'ch',
  },
  {
    name: "Cote d'Ivoire",
    prefix: '+225',
    code: 'ci',
  },
  {
    name: 'Cook Islands',
    prefix: '+682',
    code: 'ck',
  },
  {
    name: 'Chile',
    prefix: '+56',
    code: 'cl',
  },
  {
    name: 'Cameroon',
    prefix: '+237',
    code: 'cm',
  },
  {
    name: 'China',
    prefix: '+86',
    code: 'cn',
  },
  {
    name: 'Colombia',
    prefix: '+57',
    code: 'co',
  },
  {
    name: 'Costa Rica',
    prefix: '+506',
    code: 'cr',
  },
  {
    name: 'Cuba',
    prefix: '+53',
    code: 'cu',
  },
  {
    name: 'Cabo Verde',
    prefix: '+238',
    code: 'cv',
  },
  {
    name: 'Christmas Island',
    prefix: '+61',
    code: 'cx',
  },
  {
    name: 'Cyprus',
    prefix: '+357',
    code: 'cy',
  },
  {
    name: 'Czech Republic',
    prefix: '+420',
    code: 'cz',
  },
  {
    name: 'Germany',
    prefix: '+49',
    code: 'de',
  },
  {
    name: 'Djibouti',
    prefix: '+253',
    code: 'dj',
  },
  {
    name: 'Denmark',
    prefix: '+45',
    code: 'dk',
  },
  {
    name: 'Dominica',
    prefix: '+1767',
    code: 'dm',
  },
  {
    name: 'Dominican Republic',
    prefix: '+1849',
    code: 'do',
  },
  {
    name: 'Algeria',
    prefix: '+213',
    code: 'dz',
  },
  {
    name: 'Ecuador',
    prefix: '+593',
    code: 'ec',
  },
  {
    name: 'Estonia',
    prefix: '+372',
    code: 'ee',
  },
  {
    name: 'Egypt',
    prefix: '+20',
    code: 'eg',
  },
  {
    name: 'Eritrea',
    prefix: '+291',
    code: 'er',
  },
  {
    name: 'Spain',
    prefix: '+34',
    code: 'es',
  },
  {
    name: 'Ethiopia',
    prefix: '+251',
    code: 'et',
  },
  {
    name: 'Finland',
    prefix: '+358',
    code: 'fi',
  },
  {
    name: 'Fiji',
    prefix: '+679',
    code: 'fj',
  },
  {
    name: 'Falkland Islands',
    prefix: '+500',
    code: 'fk',
  },
  {
    name: 'Federated States of Micronesia',
    prefix: '+691',
    code: 'fm',
  },
  {
    name: 'Faroe Islands',
    prefix: '+298',
    code: 'fo',
  },
  {
    name: 'France',
    prefix: '+33',
    code: 'fr',
  },
  {
    name: 'Gabon',
    prefix: '+241',
    code: 'ga',
  },
  {
    name: 'United Kingdom',
    prefix: '+44',
    code: 'gb',
  },
  {
    name: 'Grenada',
    prefix: '+1473',
    code: 'gd',
  },
  {
    name: 'Georgia',
    prefix: '+995',
    code: 'ge',
  },
  {
    name: 'French Guiana',
    prefix: '+594',
    code: 'gf',
  },
  {
    name: 'Guernsey',
    prefix: '+44',
    code: 'gg',
  },
  {
    name: 'Ghana',
    prefix: '+233',
    code: 'gh',
  },
  {
    name: 'Gibraltar',
    prefix: '+350',
    code: 'gi',
  },
  {
    name: 'Greenland',
    prefix: '+299',
    code: 'gl',
  },
  {
    name: 'Gambia',
    prefix: '+220',
    code: 'gm',
  },
  {
    name: 'Guinea',
    prefix: '+224',
    code: 'gn',
  },
  {
    name: 'Guadeloupe',
    prefix: '+590',
    code: 'gp',
  },
  {
    name: 'Equatorial Guinea',
    prefix: '+240',
    code: 'gq',
  },
  {
    name: 'Greece',
    prefix: '+30',
    code: 'gr',
  },
  {
    name: 'South Georgia and the South Sandwich Islands',
    prefix: '+500',
    code: 'gs',
  },
  {
    name: 'Guatemala',
    prefix: '+502',
    code: 'gt',
  },
  {
    name: 'Guam',
    prefix: '+1671',
    code: 'gu',
  },
  {
    name: 'Guinea-Bissau',
    prefix: '+245',
    code: 'gw',
  },
  {
    name: 'Guyana',
    prefix: '+595',
    code: 'gy',
  },
  {
    name: 'Hong Kong',
    prefix: '+852',
    code: 'hk',
  },
  {
    name: 'Honduras',
    prefix: '+504',
    code: 'hn',
  },
  {
    name: 'Croatia',
    prefix: '+385',
    code: 'hr',
  },
  {
    name: 'Haiti',
    prefix: '+509',
    code: 'ht',
  },
  {
    name: 'Hungary',
    prefix: '+36',
    code: 'hu',
  },
  {
    name: 'Indonesia',
    prefix: '+62',
    code: 'id',
  },
  {
    name: 'Ireland',
    prefix: '+353',
    code: 'ie',
  },
  {
    name: 'Israel',
    prefix: '+972',
    code: 'il',
  },
  {
    name: 'Isle of Man',
    prefix: '+44',
    code: 'im',
  },
  {
    name: 'India',
    prefix: '+91',
    code: 'in',
  },
  {
    name: 'British Indian Ocean Territory',
    prefix: '+246',
    code: 'io',
  },
  {
    name: 'Iraq',
    prefix: '+964',
    code: 'iq',
  },
  {
    name: 'Iran (Islamic Republic of)',
    prefix: '+98',
    code: 'ir',
  },
  {
    name: 'Iceland',
    prefix: '+354',
    code: 'is',
  },
  {
    name: 'Italy',
    prefix: '+39',
    code: 'it',
  },
  {
    name: 'Jersey',
    prefix: '+44',
    code: 'je',
  },
  {
    name: 'Jamaica',
    prefix: '+1876',
    code: 'jm',
  },
  {
    name: 'Jordan',
    prefix: '+962',
    code: 'jo',
  },
  {
    name: 'Japan',
    prefix: '+81',
    code: 'jp',
  },
  {
    name: 'Kenya',
    prefix: '+254',
    code: 'ke',
  },
  {
    name: 'Kyrgyzstan',
    prefix: '+996',
    code: 'kg',
  },
  {
    name: 'Cambodia',
    prefix: '+855',
    code: 'kh',
  },
  {
    name: 'Kiribati',
    prefix: '+686',
    code: 'ki',
  },
  {
    name: 'Comoros',
    prefix: '+269',
    code: 'km',
  },
  {
    name: 'Saint Kitts and Nevis',
    prefix: '+1869',
    code: 'kn',
  },
  {
    name: 'South Korea',
    prefix: '+82',
    code: 'kr',
  },
  {
    name: 'Kuwait',
    prefix: '+965',
    code: 'kw',
  },
  {
    name: 'Cayman Islands',
    prefix: '+ 345',
    code: 'ky',
  },
  {
    name: 'Kazakhstan',
    prefix: '+77',
    code: 'kz',
  },
  {
    name: 'Laos',
    prefix: '+856',
    code: 'la',
  },
  {
    name: 'Lebanon',
    prefix: '+961',
    code: 'lb',
  },
  {
    name: 'Saint Lucia',
    prefix: '+1758',
    code: 'lc',
  },
  {
    name: 'Liechtenstein',
    prefix: '+423',
    code: 'li',
  },
  {
    name: 'Sri Lanka',
    prefix: '+94',
    code: 'lk',
  },
  {
    name: 'Liberia',
    prefix: '+231',
    code: 'lr',
  },
  {
    name: 'Lesotho',
    prefix: '+266',
    code: 'ls',
  },
  {
    name: 'Lithuania',
    prefix: '+370',
    code: 'lt',
  },
  {
    name: 'Luxembourg',
    prefix: '+352',
    code: 'lu',
  },
  {
    name: 'Latvia',
    prefix: '+371',
    code: 'lv',
  },
  {
    name: 'Libya',
    prefix: '+218',
    code: 'ly',
  },
  {
    name: 'Morocco',
    prefix: '+212',
    code: 'ma',
  },
  {
    name: 'Monaco',
    prefix: '+377',
    code: 'mc',
  },
  {
    name: 'Moldova',
    prefix: '+373',
    code: 'md',
  },
  {
    name: 'Montenegro',
    prefix: '+382',
    code: 'me',
  },
  {
    name: 'Saint Martin',
    prefix: '+590',
    code: 'mf',
  },
  {
    name: 'Madagascar',
    prefix: '+261',
    code: 'mg',
  },
  {
    name: 'Marshall Islands',
    prefix: '+692',
    code: 'mh',
  },
  {
    name: 'North Macedonia',
    prefix: '+389',
    code: 'mk',
  },
  {
    name: 'Mali',
    prefix: '+223',
    code: 'ml',
  },
  {
    name: 'Myanmar',
    prefix: '+95',
    code: 'mm',
  },
  {
    name: 'Mongolia',
    prefix: '+976',
    code: 'mn',
  },
  {
    name: 'Macau',
    prefix: '+853',
    code: 'mo',
  },
  {
    name: 'Northern Mariana Islands',
    prefix: '+1670',
    code: 'mp',
  },
  {
    name: 'Martinique',
    prefix: '+596',
    code: 'mq',
  },
  {
    name: 'Mauritania',
    prefix: '+222',
    code: 'mr',
  },
  {
    name: 'Montserrat',
    prefix: '+1664',
    code: 'ms',
  },
  {
    name: 'Malta',
    prefix: '+356',
    code: 'mt',
  },
  {
    name: 'Mauritius',
    prefix: '+230',
    code: 'mu',
  },
  {
    name: 'Maldives',
    prefix: '+960',
    code: 'mv',
  },
  {
    name: 'Malawi',
    prefix: '+265',
    code: 'mw',
  },
  {
    name: 'Mexico',
    prefix: '+52',
    code: 'mx',
  },
  {
    name: 'Malaysia',
    prefix: '+60',
    code: 'my',
  },
  {
    name: 'Mozambique',
    prefix: '+258',
    code: 'mz',
  },
  {
    name: 'Namibia',
    prefix: '+264',
    code: 'na',
  },
  {
    name: 'New Caledonia',
    prefix: '+687',
    code: 'nc',
  },
  {
    name: 'Niger',
    prefix: '+227',
    code: 'ne',
  },
  {
    name: 'Norfolk Island',
    prefix: '+672',
    code: 'nf',
  },
  {
    name: 'Nigeria',
    prefix: '+234',
    code: 'ng',
  },
  {
    name: 'Nicaragua',
    prefix: '+505',
    code: 'ni',
  },
  {
    name: 'Netherlands',
    prefix: '+31',
    code: 'nl',
  },
  {
    name: 'Norway',
    prefix: '+47',
    code: 'no',
  },
  {
    name: 'Nepal',
    prefix: '+977',
    code: 'np',
  },
  {
    name: 'Nauru',
    prefix: '+674',
    code: 'nr',
  },
  {
    name: 'Niue',
    prefix: '+683',
    code: 'nu',
  },
  {
    name: 'New Zealand',
    prefix: '+64',
    code: 'nz',
  },
  {
    name: 'Oman',
    prefix: '+968',
    code: 'om',
  },
  {
    name: 'Panama',
    prefix: '+507',
    code: 'pa',
  },
  {
    name: 'Peru',
    prefix: '+51',
    code: 'pe',
  },
  {
    name: 'French Polynesia',
    prefix: '+689',
    code: 'pf',
  },
  {
    name: 'Papua New Guinea',
    prefix: '+675',
    code: 'pg',
  },
  {
    name: 'Philippines',
    prefix: '+63',
    code: 'ph',
  },
  {
    name: 'Pakistan',
    prefix: '+92',
    code: 'pk',
  },
  {
    name: 'Poland',
    prefix: '+48',
    code: 'pl',
  },
  {
    name: 'Saint Pierre and Miquelon',
    prefix: '+508',
    code: 'pm',
  },
  {
    name: 'Pitcairn',
    prefix: '+872',
    code: 'pn',
  },
  {
    name: 'Puerto Rico',
    prefix: '+1939',
    code: 'pr',
  },
  {
    name: 'State of Palestine',
    prefix: '+970',
    code: 'ps',
  },
  {
    name: 'Portugal',
    prefix: '+351',
    code: 'pt',
  },
  {
    name: 'Palau',
    prefix: '+680',
    code: 'pw',
  },
  {
    name: 'Paraguay',
    prefix: '+595',
    code: 'py',
  },
  {
    name: 'Qatar',
    prefix: '+974',
    code: 'qa',
  },
  {
    name: 'Reunion',
    prefix: '+262',
    code: 're',
  },
  {
    name: 'Romania',
    prefix: '+40',
    code: 'ro',
  },
  {
    name: 'Serbia',
    prefix: '+381',
    code: 'rs',
  },
  {
    name: 'Russia',
    prefix: '+7',
    code: 'ru',
  },
  {
    name: 'Rwanda',
    prefix: '+250',
    code: 'rw',
  },
  {
    name: 'Saudi Arabia',
    prefix: '+966',
    code: 'sa',
  },
  {
    name: 'Solomon Islands',
    prefix: '+677',
    code: 'sb',
  },
  {
    name: 'Seychelles',
    prefix: '+248',
    code: 'sc',
  },
  {
    name: 'Sudan',
    prefix: '+249',
    code: 'sd',
  },
  {
    name: 'Sweden',
    prefix: '+46',
    code: 'se',
  },
  {
    name: 'Singapore',
    prefix: '+65',
    code: 'sg',
  },
  {
    name: 'Saint Helena, Ascension and Tristan da Cunha',
    prefix: '+290',
    code: 'sh',
  },
  {
    name: 'Slovenia',
    prefix: '+386',
    code: 'si',
  },
  {
    name: 'Svalbard and Jan Mayen',
    prefix: '+47',
    code: 'sj',
  },
  {
    name: 'Slovakia',
    prefix: '+421',
    code: 'sk',
  },
  {
    name: 'Sierra Leone',
    prefix: '+232',
    code: 'sl',
  },
  {
    name: 'San Marino',
    prefix: '+378',
    code: 'sm',
  },
  {
    name: 'Senegal',
    prefix: '+221',
    code: 'sn',
  },
  {
    name: 'Somalia',
    prefix: '+252',
    code: 'so',
  },
  {
    name: 'Suriname',
    prefix: '+597',
    code: 'sr',
  },
  {
    name: 'South Sudan',
    prefix: '+211',
    code: 'ss',
  },
  {
    name: 'Sao Tome and Principe',
    prefix: '+239',
    code: 'st',
  },
  {
    name: 'El Salvador',
    prefix: '+503',
    code: 'sv',
  },
  {
    name: 'Syrian Arab Republic',
    prefix: '+963',
    code: 'sy',
  },
  {
    name: 'Swaziland',
    prefix: '+268',
    code: 'sz',
  },
  {
    name: 'Turks and Caicos Islands',
    prefix: '+1649',
    code: 'tc',
  },
  {
    name: 'Chad',
    prefix: '+235',
    code: 'td',
  },
  {
    name: 'Togo',
    prefix: '+228',
    code: 'tg',
  },
  {
    name: 'Thailand',
    prefix: '+66',
    code: 'th',
  },
  {
    name: 'Tajikistan',
    prefix: '+992',
    code: 'tj',
  },
  {
    name: 'Tokelau',
    prefix: '+690',
    code: 'tk',
  },
  {
    name: 'Timor-Leste',
    prefix: '+670',
    code: 'tl',
  },
  {
    name: 'Turkmenistan',
    prefix: '+993',
    code: 'tm',
  },
  {
    name: 'Tunisia',
    prefix: '+216',
    code: 'tn',
  },
  {
    name: 'Tonga',
    prefix: '+676',
    code: 'to',
  },
  {
    name: 'Turkey',
    prefix: '+90',
    code: 'tr',
  },
  {
    name: 'Trinidad and Tobago',
    prefix: '+1868',
    code: 'tt',
  },
  {
    name: 'Tuvalu',
    prefix: '+688',
    code: 'tv',
  },
  {
    name: 'Taiwan',
    prefix: '+886',
    code: 'tw',
  },
  {
    name: 'Tanzania',
    prefix: '+255',
    code: 'tz',
  },
  {
    name: 'Ukraine',
    prefix: '+380',
    code: 'ua',
  },
  {
    name: 'Uganda',
    prefix: '+256',
    code: 'ug',
  },
  {
    name: 'United States of America',
    prefix: '+1',
    code: 'us',
  },
  {
    name: 'Uruguay',
    prefix: '+598',
    code: 'uy',
  },
  {
    name: 'Uzbekistan',
    prefix: '+998',
    code: 'uz',
  },
  {
    name: 'Holy See',
    prefix: '+379',
    code: 'va',
  },
  {
    name: 'Saint Vincent and the Grenadines',
    prefix: '+1784',
    code: 'vc',
  },
  {
    name: 'Venezuela (Bolivarian Republic of)',
    prefix: '+58',
    code: 've',
  },
  {
    name: 'Virgin Islands (British)',
    prefix: '+1284',
    code: 'vg',
  },
  {
    name: 'Virgin Islands (U.S.)',
    prefix: '+1340',
    code: 'vi',
  },
  {
    name: 'Vietnam',
    prefix: '+84',
    code: 'vn',
  },
  {
    name: 'Vanuatu',
    prefix: '+678',
    code: 'vu',
  },
  {
    name: 'Wallis and Futuna',
    prefix: '+681',
    code: 'wf',
  },
  {
    name: 'Samoa',
    prefix: '+685',
    code: 'ws',
  },
  {
    name: 'Yemen',
    prefix: '+967',
    code: 'ye',
  },
  {
    name: 'Mayotte',
    prefix: '+262',
    code: 'yt',
  },
  {
    name: 'South Africa',
    prefix: '+27',
    code: 'za',
  },
  {
    name: 'Zambia',
    prefix: '+260',
    code: 'zm',
  },
  {
    name: 'Zimbabwe',
    prefix: '+263',
    code: 'zw',
  },
];
